/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
import ReactPDF from '@react-pdf/renderer';
import { Table, TD, TH, TR } from '@ag-media/react-pdf-table';
import { format } from 'date-fns';
import { htmlToText } from 'html-to-text';
import { columnWidths, styles, tableStyles } from './style';
import { ICompany, IContactPerson, IInvoice } from '../../../types/types';
import { formatDate } from '../../../utils/format';

export default function InvoiceCanvas({
  invoice,
  company,
  contact_person,
}: {
  invoice: IInvoice;
  company: ICompany;
  contact_person?: IContactPerson | null;
}) {
  const parsedDesc = invoice?.description ? htmlToText(invoice.description) : '';

  return (
    <ReactPDF.Document>
      <ReactPDF.Page size="A4" style={styles.page}>
        <ReactPDF.View style={styles.headerRow}>
          <ReactPDF.View>
            {company?.logo ? <ReactPDF.Image src={company?.logo} style={styles.logo} /> : <ReactPDF.View />}
          </ReactPDF.View>
          <ReactPDF.View style={[styles.spaceY, styles.alignEnd, styles.paddingBottom]}>
            <ReactPDF.Text style={styles.invoiceTitle}>Invoice</ReactPDF.Text>
            <ReactPDF.View style={styles.headerRightInfo}>
              <ReactPDF.View style={[styles.alignEnd, styles.textBold]}>
                <ReactPDF.Text>Reference</ReactPDF.Text>
                <ReactPDF.Text>Date</ReactPDF.Text>
                <ReactPDF.Text>Due Date</ReactPDF.Text>
                <ReactPDF.Text style={[styles.maxWidth, styles.textRight]}>Tax Identification Number</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={styles.alignEnd}>
                <ReactPDF.Text>{invoice?.invoice_number}</ReactPDF.Text>
                <ReactPDF.Text>{invoice?.date ? formatDate(invoice?.date) : 'N/A'}</ReactPDF.Text>
                <ReactPDF.Text>{invoice?.due_date ? formatDate(invoice?.due_date) : 'N/A'}</ReactPDF.Text>
                <ReactPDF.Text>{company?.taxIdent || '-'}</ReactPDF.Text>
              </ReactPDF.View>
            </ReactPDF.View>
          </ReactPDF.View>
        </ReactPDF.View>

        <ReactPDF.View style={styles.information}>
          <ReactPDF.View style={[styles.spaceY, styles.widthHalf, styles.textBold]}>
            <ReactPDF.Text style={styles.darkBlueColor}>Our Information</ReactPDF.Text>
            <ReactPDF.View style={styles.line} />
            <ReactPDF.Text style={[styles.textBold, styles.marginBottom]}>{company?.name || '-'}</ReactPDF.Text>
            {company?.address_line_1 && <ReactPDF.Text>{company?.address_line_1}</ReactPDF.Text>}

            {company?.address_line_2 ? (
              company?.city ? (
                <ReactPDF.Text>
                  {company?.address_line_2} {company?.city}
                </ReactPDF.Text>
              ) : (
                <ReactPDF.Text>{company?.address_line_2}</ReactPDF.Text>
              )
            ) : company?.city ? (
              <ReactPDF.Text>{company?.city}</ReactPDF.Text>
            ) : (
              ''
            )}
            {company?.state ? (
              company?.zip_code ? (
                <ReactPDF.Text>
                  {company?.state}, {company?.zip_code}
                </ReactPDF.Text>
              ) : (
                <ReactPDF.Text>{company?.state}</ReactPDF.Text>
              )
            ) : company?.zip_code ? (
              <ReactPDF.Text>{company?.zip_code}</ReactPDF.Text>
            ) : (
              ''
            )}
            {company?.country && <ReactPDF.Text>{company?.country}</ReactPDF.Text>}
            {company?.phone && <ReactPDF.Text>Phone: {company?.phone}</ReactPDF.Text>}
            {company?.email && <ReactPDF.Text>Email: {company?.email}</ReactPDF.Text>}
          </ReactPDF.View>
          <ReactPDF.View style={[styles.spaceY, styles.widthHalf, styles.textBold]}>
            <ReactPDF.Text style={styles.darkBlueColor}>Billing For</ReactPDF.Text>
            <ReactPDF.View style={styles.line} />
            <ReactPDF.Text style={[styles.textBold, styles.marginBottom]}>{invoice?.partner?.name}</ReactPDF.Text>
            <ReactPDF.Text>{contact_person?.name}</ReactPDF.Text>

            {contact_person?.phone ? (
              <ReactPDF.Text>Phone: {contact_person?.phone}</ReactPDF.Text>
            ) : (
              <ReactPDF.Text>Phone: {invoice?.partner?.phone}</ReactPDF.Text>
            )}
            {contact_person?.email ? (
              <ReactPDF.Text>Email: {contact_person?.email}</ReactPDF.Text>
            ) : (
              <ReactPDF.Text>Email: {invoice?.partner?.email}</ReactPDF.Text>
            )}
          </ReactPDF.View>
        </ReactPDF.View>

        {/* Tabel kustom dengan lebar kolom yang disesuaikan */}
        <ReactPDF.View style={tableStyles.mainTable}>
          {/* Header tabel */}
          <ReactPDF.View style={tableStyles.fixedRow}>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.product }]}>
              <ReactPDF.Text>Product</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.description }]}>
              <ReactPDF.Text>Description</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.quantity, textAlign: 'center' }]}>
              <ReactPDF.Text>Qty</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.price, textAlign: 'right' }]}>
              <ReactPDF.Text>Price(Rp)</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.discount, textAlign: 'right' }]}>
              <ReactPDF.Text>Discount</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.tax, textAlign: 'right' }]}>
              <ReactPDF.Text>Tax</ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={[tableStyles.headerCell, { width: columnWidths.amount, textAlign: 'right' }]}>
              <ReactPDF.Text>Amount</ReactPDF.Text>
            </ReactPDF.View>
          </ReactPDF.View>

          {/* Baris-baris data */}
          {invoice?.invoice_products?.map((item, index) => (
            <ReactPDF.View key={index} style={tableStyles.fixedRow} wrap={false}>
              <ReactPDF.View style={[tableStyles.productCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{item.name}</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.descriptionCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text
                  style={{
                    lineHeight: 0.5,
                  }}
                >
                  {htmlToText(item.description) || '-'}
                </ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.quantityCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{item.quantity}</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.priceCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{Intl.NumberFormat('id-ID').format(item.price ?? 0)}</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.discountCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{item.discount || '-'}</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.taxCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{item.tax || '-'}</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[tableStyles.amountCell, { backgroundColor: '#f1f1f1' }]}>
                <ReactPDF.Text>{Intl.NumberFormat('id-ID').format(item.amount ?? 0)}</ReactPDF.Text>
              </ReactPDF.View>
            </ReactPDF.View>
          ))}
        </ReactPDF.View>

        <ReactPDF.View style={styles.totals}>
          <ReactPDF.View
            style={{
              minWidth: '256px',
            }}
          >
            <ReactPDF.View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '8px',
              }}
            >
              <ReactPDF.Text style={[styles.textBold]}>Sub Total</ReactPDF.Text>
              <ReactPDF.Text>
                {Intl.NumberFormat('id-ID', {
                  style: 'currency',
                  currency: 'IDR',
                }).format(invoice?.subtotal ?? 0)}
              </ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={styles.lineMarginBottom} />
            <ReactPDF.View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '8px',
              }}
            >
              <ReactPDF.Text style={[styles.textBold]}>Tax</ReactPDF.Text>
              <ReactPDF.Text>
                {Intl.NumberFormat('id-ID', {
                  style: 'currency',
                  currency: 'IDR',
                }).format(invoice?.tax ?? 0)}
              </ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={styles.lineMarginBottom} />
            <ReactPDF.View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '8px',
              }}
            >
              <ReactPDF.Text style={[styles.textBold]}>Total</ReactPDF.Text>
              <ReactPDF.Text>
                {Intl.NumberFormat('id-ID', {
                  style: 'currency',
                  currency: 'IDR',
                }).format(invoice?.total ?? 0)}
              </ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={styles.lineMarginBottom} />
            <ReactPDF.View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '8px',
              }}
            >
              <ReactPDF.Text style={[styles.amountDue, styles.textBold]}>Amount Due:</ReactPDF.Text>
              <ReactPDF.Text style={[styles.amountDue]}>
                {Intl.NumberFormat('id-ID', {
                  style: 'currency',
                  currency: 'IDR',
                }).format(invoice?.amount_due ?? 0)}
              </ReactPDF.Text>
            </ReactPDF.View>
            <ReactPDF.View style={styles.lineMarginBottom} />
          </ReactPDF.View>
        </ReactPDF.View>
        <ReactPDF.View style={styles.information}>
          <ReactPDF.View style={[styles.spaceY, styles.textBold, styles.widthHalf]}>
            <ReactPDF.Text style={styles.darkBlueColor}>Notes</ReactPDF.Text>
            <ReactPDF.View style={styles.line} />
            {invoice?.description && <ReactPDF.Text style={styles.desc}>{parsedDesc}</ReactPDF.Text>}
          </ReactPDF.View>
          <ReactPDF.View style={[styles.widthHalf, styles.textBold, styles.signature]}>
            <ReactPDF.Text>{invoice?.date ? format(invoice?.date, 'LLL dd, y') : 'N/A'}</ReactPDF.Text>
            {invoice?.signature ? <ReactPDF.Image src={invoice?.signature} style={styles.logo} /> : <ReactPDF.View />}
            <ReactPDF.Text style={[styles.textBold]}>{invoice?.signature_name}</ReactPDF.Text>
          </ReactPDF.View>
        </ReactPDF.View>
      </ReactPDF.Page>
    </ReactPDF.Document>
  );
}
